import { render, staticRenderFns } from "./Serial-Number-Dialog.vue?vue&type=template&id=2f34341a&scoped=true"
import script from "./Serial-Number-Dialog.vue?vue&type=script&lang=js"
export * from "./Serial-Number-Dialog.vue?vue&type=script&lang=js"
import style0 from "./Serial-Number-Dialog.vue?vue&type=style&index=0&id=2f34341a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34341a",
  null
  
)

export default component.exports